import { GoogleLogin } from "@react-oauth/google";
import axios from "axios";
import { API_IP } from "../global_variables";
import { useNavigate } from "react-router-dom";
import { axiosReqConfig } from "../functions/axiosRequest";
// Handles loging in via google authenticaror.

const LoginButton = ({ setLogin, setUser }) => {
  const navigate = useNavigate();
  const handleLoginSuccess = async (credentialResponse) => {
    console.log("Login Success:", credentialResponse);
    const { data } = await axios({
      method: "post",
      url: `${API_IP}/api/googleLogin`,
      headers: {},
      data: {
        idToken: credentialResponse.credential,
        device_token: null,
        platform: "web", // This is the body part
      },
    });
    localStorage.setItem("token", data.token);
    localStorage.setItem("username", data.username);
    localStorage.setItem("userId", data.userId);
    navigate("/main", {
      state: { user: { username: data.username } },
    });
    setLogin(true);

    setUser({ username: data.username, userId: data.userId });

    console.log("Login successful:", data);
    // Handle the successful login response (e.g., send the token to your backend)
  };

  const handleLoginFailure = () => {
    console.log("Login Failed");
    // Handle the failed login response
  };

  return (
    <GoogleLogin onSuccess={handleLoginSuccess} onError={handleLoginFailure} />
  );
};
export default LoginButton;
